import {Component, OnDestroy, OnInit} from '@angular/core';
import 'rxjs/add/operator/catch';
import {Store} from '@ngrx/store';
import {ACTIVE_SEARCH_REMOVE, OrderCompletionClear} from '@store/actions';
import {selectSearchResults} from '@store/reducers';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs/Subject';

@Component({
  selector: 'consignment',
  template: `
    <div class="consignment-container">
      <router-outlet></router-outlet>
    </div>
  `,
  styleUrls: ['./consignment.component.scss']
})

export class ConsignmentComponent implements OnInit, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.store.select(selectSearchResults)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.store.dispatch({
      type: ACTIVE_SEARCH_REMOVE
    });
    this.store.dispatch(new OrderCompletionClear());
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/consignment/consignment.component.ts